import { gsap } from 'gsap'

/**
 * A reading highlight: one fragment at a time takes the animation colour, the others keep the
 * element's own colour, and the text ends unchanged. In and out both follow the reading order: a
 * highlight that reads backwards is never what the text means.
 *
 * The active fragment follows from the progress of a single tween, not from a series of sets: a
 * `clearProps` set cannot be reverted, so a scrubbed trigger moving back lost the highlight. Every
 * render now sets the highlight from the progress alone, in either direction.
 */
export function getTextHighlightAnimation (element, settings) {
    const color = settings.color ?? 'transparent'

    return {
        sequence (targets, duration) {
            let active = null
            const highlight = (target) => {
                if (target === active) {
                    return
                }
                if (active) {
                    gsap.set(active, { clearProps: 'color' })
                }
                if (target) {
                    gsap.set(target, { color })
                }
                active = target
            }

            return gsap.to({}, {
                duration,
                ease: 'none',
                onUpdate () {
                    const progress = this.progress()
                    highlight(progress > 0 && progress < 1 ? targets[Math.floor(progress * targets.length)] : null)
                },
            })
        },
    }
}
